export var goNext = function(dispatch) {
    return function() {
        return dispatch({
            type: 'next'
        });
    };
};
export var goPrevious = function(dispatch) {
    return function() {
        return dispatch({
            type: 'previous'
        });
    };
};
export var setSlideCount = function(dispatch) {
    return function(value) {
        return dispatch({
            type: 'set-slide-count',
            value: value
        });
    };
};
export var setColCount = function(dispatch) {
    return function(value) {
        return dispatch({
            type: 'set-col-count',
            value: value
        });
    };
};
export var setSlideIndex = function(dispatch) {
    return function(value) {
        return dispatch({
            type: 'set-slide-index',
            value: value
        });
    };
};
export var setSlideLabels = function(dispatch) {
    return function(value) {
        dispatch({
            type: 'set-slide-labels',
            value: value
        });
    };
};
